<template>
  <div id="app">
    <!-- 顶部导航 -->
    <headerCc v-if="!isRcIframe && showHeader"></headerCc>
    <!-- 主界面 -->
    <el-main
      class="scrollbar"
      id="main-box"
      :class="{'iframeMain': isRcIframe, 'sourceNew': isSourceNew, 'activateMain': isActivate}">
      <!-- 左侧menu（激活页不显示） -->
      <menuTab
        v-if="menuArr && !isRcIframe && !isActivate"
        :menuArr="menuArr"/>
      <div class="content-box">
        <!-- router下的tab -->
        <RouterTop
          v-if="isRoute && !isRcIframe"
          class="topMenu"
        />
        <router-view :key="dataMark"></router-view>
      </div>
    </el-main>
    <component
      v-if="noticeWrap"
      :is="noticeWrap"
      :dialogVisible.sync="visible.notice"
      :msg='noticeMsg'></component>
  </div>
</template>

<script>
import HeaderCc from '@/components/HeaderCc'
import MenuTab from '@/components/Menu'
import RouterTop from '@/components/RouterTop'
import { mapActions, mapState } from 'vuex'
import Bus from '@/assets/js/vueBus.js'
import Tool from '@/assets/js/utils'
import { routeDataMarks } from './config.js'
import { googleAnalytics } from '@/assets/js/loadSudoku'
import { redirectUrl } from '@/assets/js/jumpLogin'
import toTips from '@/assets/js/toTipsObj'

const noticeComponent = () => import('@/components/notice')
export default {
  name: 'App',
  data () {
    return {
      routeDataMarks,
      dataMark: '',
      visible: {
        notice: false
      },
      noticeMsg: [],
      role: null,
      menuArr: [],
      refreshCookieTimer: null,
      showHeader: false,
      noticeWrap: null
    }
  },
  components: {
    HeaderCc,
    MenuTab,
    RouterTop
  },
  computed: {
    ...mapState('common', {
      StateObj: state => state,
      accountType: state => state.baseUserInfo.role,
      userInfo: state => state.baseUserInfo
    }),
    ...mapState({
      isRcIframe: state => state.isRcIframe,
      featureFlag: state => state.featureFlag
    }),
    isRoute () {
      const dataMark = this.dataMark ? this.dataMark.split('/')[1] : ''
      return this.routeDataMarks.allChilds.indexOf(dataMark) >= 0
    },
    isSourceNew () {
      const dataMark = this.dataMark ? this.dataMark.split('/')[1] : ''
      return dataMark === 'hmn'
    },
    isActivate () {
      // 优先用已解析的路由；但 router.beforeEach 是异步守卫，app 启动到 next() 之间
      // $route 仍停留在初始 '/'（START_LOCATION）。此空窗期 menuArr 可能已被填充，
      // 导致左侧菜单在跳转 activate 时短暂闪现。故 $route 未解析(仍为 '/')时回退读真实 URL hash。
      const routePath = this.$route && this.$route.path
      if (routePath && routePath !== '/') return routePath === '/activate'
      return (window.location.hash || '').indexOf('/activate') > -1
    }
  },
  watch: {
    $route (to, from) {
      this.dataMark = to.path
      Bus.$emit('updateAccountInfo')
    },
    'userInfo.id': {
      handler (val) {
        if (val) {
          this.showHeader = true
          this.initWebsocket()
        }
      },
      immediate: true
    },
    'StateObj.baseUrl.authServerName': {
      handler (val, oldVal) {
        if (val && !oldVal) {
          redirectUrl()
          this.getMenuInfo()
          this.getPromptMsgCont()
          this.addMessageListener()
        }
      },
      immediate: true
    }
  },
  async created () {
    if (!this.$store.state.common.baseUrl && !localStorage.getItem('newCCInitConfig')) {
      await this.$store.dispatch('common/getInitConfig')
    }
    Bus.$on('roleInfo', async role => {
      if (this.role !== null || !['3', '4'].includes(role)) return
      this.role = role
      await this.showNotice()
      setTimeout(() => {
        const modalDom = document.querySelector('body .v-modal')
        if (this.visible.notice && modalDom) {
          modalDom.classList.add('notice')
        }
      }, 100)
    })
    Bus.$on('clearMonitor', () => {
      this.clearMonitor()
    })
    Bus.$on('setClearMonitor', obj => {
      this.setClearMonitor(obj)
    })
  },
  mounted () {
    this.$store.state.isRcIframe = window.parent !== window
    this.setRem()
    // window.onunhandledrejection = event => {
    //   console.error('Unhandled Promise rejection:', event.reason)
    // }
    // 加载完毕时加载其他插件
    this.$nextTick(() => {
      // 根据页面是否存在video，定时刷新Cookie
      this.refreshCookie()
      if (Tool.checkIsCom()) {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => {
            this.initGoogleInfo()
          })
        } else {
          setTimeout(() => {
            this.initGoogleInfo()
          }, 1000)
        }
      }
    })
  },
  methods: {
    ...mapActions('common', [
      'baseUrl',
      'baseUserInfo'
    ]),
    initGoogleInfo () {
      if (this.StateObj.baseUrl && this.StateObj.baseUrl.googleAnalyticsAccount) googleAnalytics(this.StateObj.baseUrl.googleAnalyticsAccount)
      Tool.dynamicLoadJs('./reference/19963008.js')
    },
    initWebsocket () {
      this.$createWebsocket.pageRequest()
      this.$createWebsocket.pageSerBusRequest()
      this.$createWebsocket.pageRWebsocket('', '', 'sendHeart')
      window.pageRequest = this.$store.state.websocket.pageRequest
    },
    clearWebsocket () {
      this.$createWebsocket.pageRWebsocket('off')
      this.$createWebsocket.pageRequest('off')
      this.$createWebsocket.pageSerBusRequest('off')
    },
    // 动态加载Notice组件
    async getNoticeWrap () {
      const noticeWrap = await noticeComponent()
      this.noticeWrap = noticeWrap.default
      this.visible.notice = true
    },
    refreshCookie () {
      this.refreshCookieTimer = setInterval(() => {
        const rtcVideoArr = document.querySelectorAll('.videoLabelCheckCookie')
        let hasVideo = false
        if (rtcVideoArr.length > 0) {
          rtcVideoArr.forEach((v, index) => {
            const dom = document.getElementsByClassName('videoLabelCheckCookie')[index]
            const domParent = dom.parentNode
            const style = window.getComputedStyle(domParent)
            const display = style.display
            if (display != 'none') hasVideo = true
          })
          if (hasVideo) {
            this.axios.get('/ccp/initLoginUser').then(() => {
            }).catch(() => {})
          }
        }
      }, this.StateObj.baseUrl && this.StateObj.baseUrl.refreshCookieTimer || 10 * 60 * 1000)
    },
    // 用于2.0
    addMessageListener () {
      // 切换语言，以及切换回admin账号时收消息
      window.addEventListener('message', event => {
        // const V2Url = 'https://local.tvunetworks.com:8082'
        const V2Url = `${window.location.protocol}//${this.StateObj.baseUrl.v2CCDomain}`
        if (event.origin === V2Url) {
          // 处理接收到的消息
          const obj = Tool.isJSON(event.data) ? JSON.parse(event.data) : event.data
          if (obj && obj.type && obj.type == 'changeLang') {
            const langSelt = obj.data
            localStorage.setItem('lang', langSelt)
            this.$i18n.locale = langSelt
          }
          if (obj && obj.type && obj.type == 'clearMonitor') {
            this.clearMonitor()
          }
        }
      })
    },
    getPromptMsgCont () {
      this.axios({
        method: 'post',
        url: '/ccp/tvucc-user/userDevice/listPreference',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        data: {}
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result.length > 0) {
            const list = res.data.result
            list.map(v => {
              if (this.accountType == 2 && (v.pn == 'errorNotify' || v.pn == 'lowBatteryNotify')) v.content = 'false'
              this.$set(this.featureFlag, v.pn, !!(v.content == 'true'))
            })
          }
        }
      }).catch(() => {})
    },
    setRem () {
      let rem = 100 // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
      document.documentElement.style.fontSize = `${rem}px`
      window.addEventListener('resize', () => {
        let rem = 100 // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
        document.documentElement.style.fontSize = `${rem}px`
      })
    },
    // 是否为第一次登陆进来
    isLogin () {
      if (localStorage.getItem('NewCCsession3.0') != localStorage.getItem('lastSession')) {
        localStorage.setItem('lastSession', localStorage.getItem('NewCCsession3.0'))
        return true
      }
      return false
    },
    async showNotice () {
      if (this.isLogin()) {
        await this.axios.post('/ccp/tvucc-alert/featureagreement/getNotice', {}).then(res => {
          if (res.status == 200 && res.data.errorCode == '0x0' && res.data.result.length) {
            this.noticeMsg = []
            res.data.result.map(v => {
              if (v.featureName.toLowerCase().includes('tokensystem')) {
                this.noticeMsg.push('TVU Anywhere Token System')
              }
              if (!this.noticeMsg.includes('TVU Grid') && v.featureName.toLowerCase().includes('grid')) {
                this.noticeMsg.push('TVU Grid')
              }
            })
            if (!this.isRcIframe) this.getNoticeWrap()
          }
        }).catch(() => {})
        return
      }
      this.visible.notice = false
      const modalDom = document.querySelector('body .v-modal')
      if (modalDom) {
        modalDom.classList.remove('notice')
      }
    },
    // 获取menu信息
    getMenuInfo () {
      this.axios.get('/ccp/tvucc-user/menu/menuInfoList').then(res => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          const supportMenuKey = [{
            dataMark: 'hm',
            name: 'Route',
            icon: 'iconfont icon-Live1'
          }, {
            dataMark: 'mv',
            name: 'Monitor',
            icon: 'iconfont icon-Monitor'
          }, {
            dataMark: 'gm',
            name: 'Grid',
            icon: 'iconfont icon-grid1'
          }, {
            dataMark: 'tkm',
            name: 'TToken',
            icon: 'iconfont icon-QR'
          }, {
            dataMark: 'rps',
            name: 'RPS',
            icon: 'iconfont icon-a-rpsone'
          }, {
            dataMark: 'smn',
            name: 'SMonitor',
            icon: 'iconfont icon-viewgallery'
          }]
          const allMenuArr = result.normalList.concat(result.moreList)
          this.menuArr = []
          supportMenuKey.forEach(v => {
            const index = allMenuArr.findIndex(m => m.dataMark == v.dataMark)
            if (index >= 0) {
              v.permission = allMenuArr[index].permission
              this.menuArr.push(v)
            }
          })
        }
      }).catch(() => {})
    },
    // 清空Monitor
    clearMonitor () {
      let supportViewAccount = window.sessionStorage.getItem('userChangeInfo')
      if (supportViewAccount && JSON.parse(supportViewAccount)) {
        supportViewAccount = JSON.parse(supportViewAccount)
        // supportUserEmail
        this.setClearMonitor({
          email: supportViewAccount.supportUserEmail,
          isMonitor: false
        })
      }
    },
    // 设置或清空Monitor方法
    setClearMonitor (obj) {
      const domain = document.domain.substring(document.domain.indexOf('.') + 1)
      const params = {
        email: obj.email,
        domain: domain
      }
      this.axios.post('/ccp/tvucc-user/user/monitorSwitch', params, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          let pathKey = 'st'
          if (this.$route.path == '/st') pathKey = 'stS'
          let userChangeInfo = ''
          if (obj.isMonitor) {
            userChangeInfo = {
              currentUserEmail: obj.email,
              supportUserEmail: this.StateObj.baseUserInfo.email
            }
          } else {
            window.sessionStorage.setItem('userChangeInfo', '')
          }
          window.sessionStorage.setItem(
            'userChangeInfo',
            JSON.stringify(userChangeInfo)
          )
          // 获取User tag前端重写
          this.getUserTags()
          // 获取用户menu信息
          this.getMenuInfo()
          // 监控时需要更新右上角用户信息
          Bus.$emit('updateAccountInfo', 'updateAccount')
          // 关闭当前用户下的websocket
          this.clearWebsocket()
          // 跳转到监控账号的路由
          this.$router.push({ path: `/${pathKey}` }).catch(() => {})
          // 跳转之后重新开启websocket
          this.$nextTick(() => {
            this.initWebsocket()
          })
          // Monitor需要向父级发消息(用于CC2.0)
          if (window.parent !== window) {
            const obj = {
              type: 'monitor',
              userChangeInfo
            }
            // const V2Url = 'https://local.tvunetworks.com:8082'
            const V2Url = `${window.location.protocol}//${this.StateObj.baseUrl.v2CCDomain}`
            window.parent.postMessage(JSON.stringify(obj), V2Url)
          }
        } else {
          const errorInfo = this.$t(toTips[res.errorCode]) || res.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {
      })
    },
    // 获取用户tag信息
    getUserTags () {
      const userGroupUrl = this.StateObj.baseUrl.userGroupUrl
      if (!userGroupUrl) return
      this.axios.get(`${userGroupUrl}/user-group/user/getUserTag`).then(res => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          const addTags = result.addTags
          const delTags = result.delTags
          const domainName = Tool.resolveCookieDomain()
          const domainPart = domainName ? `domain=${domainName};` : ''
          const httpsFlag = window.location.protocol.includes('https')
          const exp = new Date()
          exp.setTime(exp.getTime() - 1)
          delTags.forEach(itm => {
            window.document.cookie = `${itm}=;path=/;${domainPart}expires=${exp.toGMTString()}`
          })
          addTags.forEach(itm => {
            window.document.cookie = `${itm.tagKey}=${itm.tagValue};path=/;${domainPart}${httpsFlag ? 'secure' : ''}`
          })
        }
      }).catch(() => {})
    }
  },
  beforeDestroy () {
    this.refreshCookieTimer && clearInterval(this.refreshCookieTimer)
    Bus.$off('clearMonitor')
    Bus.$off('setClearMonitor')
  }
}
</script>
<style lang="less">
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
#main-box {
  flex: 1;
  display: flex;
  flex-direction: row;
  color: #dbdbdb;
  background: #242424;
  // height: calc(100vh - 64px);
  width: 100%;
  .topMenu {
    height: 39px;
    color: #dbdbdb;
    background: #242424;
  }
  .content-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: calc(100% - 60px);
  }
  .content {
    // height: calc(100% - 64px);
    flex: 1;
    overflow-y: auto;
  }
  // &.isRouterMain {
  //   height: calc(100% - 104px);
  // }
  &.iframeMain {
    width: 100%;
    height: 100%;
    .content-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
  // 激活页无左侧 menu，内容占满整行
  &.activateMain {
    .content-box {
      width: 100%;
    }
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
}
@media (max-width: 1024px) {
  #main-box {
    height: calc(100% - 60px);
  }
}
</style>
